<template>
  <el-container v-loading="isLoading" class="Edit">
    <el-header class="Edit-header">
      <el-page-header @back="close" :content="title"></el-page-header>
    </el-header>
    <el-main class="Edit-main">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="创意类型名称" prop="ideaTypeName" style="width: 500px">
          <el-input v-model="form.ideaTypeName"></el-input>
        </el-form-item>
        <el-form-item label="代码位类型" prop="slotType">
          <el-select v-model="form.slotType">
            <el-option v-for="(item, index) in myOption.slotType" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item required label="创意类型元素">
          <ul class="idea-type">
            <li v-for="(item, index) in ideaData" :key="index">
              <el-checkbox v-model="item.checked" style="width: 120px">{{myOption.getIdData('ideaType', item.assetsId, 'name')}}</el-checkbox>
              <ul v-if="item.checked" class="idea-type-param">
                <li>
                  <el-radio-group v-model="item.required" size="mini">
                    <el-radio-button :label="myOption.is.false" >选填</el-radio-button>
                    <el-radio-button :label="myOption.is.true" >必填</el-radio-button>
                  </el-radio-group>
                </li>
                <li v-if="item.data.width !== undefined">
                  <span style="margin-right: 6px;">宽度</span>
                  <el-input v-model="item.data.width" size="mini" style="width: 80px;" @input="errorNumber(index, 'data', 'width')"></el-input>
                  <span style="margin-left: 6px">px</span>
                  <span style="margin-left: 6px;color: #F56C6C">{{item.tip[0]}}</span>
                </li>
                <li v-if="item.data.height !== undefined">
                  <span style="margin-right: 6px;">高度</span>
                  <el-input v-model="item.data.height" size="mini" style="width: 80px;" @input="errorNumber(index, 'data', 'height')"></el-input>
                  <span style="margin-left: 6px">px</span>
                  <span style="margin-left: 6px;color: #F56C6C">{{item.tip[1]}}</span>
                </li>
                <li v-if="item.data.minLen !== undefined">
                  <span style="margin-right: 6px;">最小长度</span>
                  <el-input v-model="item.data.minLen" size="mini" style="width: 80px;" @input="errorNumber(index, 'data', 'minLen')"></el-input>
                  <span style="margin-left: 6px">字</span>
                  <span style="margin-left: 6px;color: #F56C6C">{{item.tip[0]}}</span>
                </li>
                <li v-if="item.data.maxLen !== undefined">
                  <span style="margin-right: 6px;">最大长度</span>
                  <el-input v-model="item.data.maxLen" size="mini" style="width: 80px;" @input="errorNumber(index, 'data', 'maxLen')">
                  </el-input><span style="margin-left: 6px">字</span>
                  <span style="margin-left: 6px;color: #F56C6C">{{item.tip[1]}}</span>
                </li>
                <li v-if="item.data.minTime !== undefined">
                  <span style="margin-right: 6px;">最小时长</span>
                  <el-input v-model="item.data.minTime" size="mini" style="width: 80px;" @input="errorNumber(index, 'data', 'minTime')">
                  </el-input><span style="margin-left: 6px">秒</span>
                  <span style="margin-left: 6px;color: #F56C6C">{{item.tip[0]}}</span>
                </li>
                <li v-if="item.data.maxTime !== undefined">
                  <span style="margin-right: 6px;">最大时长</span>
                  <el-input v-model="item.data.maxTime" size="mini" style="width: 80px;" @input="errorNumber(index, 'data', 'maxTime')">
                  </el-input><span style="margin-left: 6px">秒</span>
                  <span style="margin-left: 6px;color: #F56C6C">{{item.tip[1]}}</span>
                </li>
                <li v-if="item.data.mimes !== undefined">
                  <el-checkbox-group v-model="item.data.mimes" :min="imgMinNum">
                    <template v-if="item.assetsId !== 17">
                      <el-checkbox label="image/jpeg">JPEG</el-checkbox>
                      <el-checkbox label="image/png">PNG</el-checkbox>
                      <el-checkbox label="image/gif">GIF</el-checkbox>
                    </template>
                    <template v-else>
                      <el-checkbox label="video/mp4">MP4</el-checkbox>
                      <el-checkbox label="video/flv">FLV</el-checkbox>
                    </template>
                  </el-checkbox-group>
                </li>
              </ul>
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="备注" prop="remark" style="width: 500px">
          <el-input type="textarea" v-model="form.remark" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">提交</el-button>
          <el-button v-if="isModel!==2" @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Edit',
  data () {
    let ideaTypeNameRule = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入创意类型名称'))
      } else {
        if (value.length < 1 || value.length > 100) {
          callback(new Error('长度在 1 到 100 个字符'))
        } else {
          if (this.isModel !== 2 || this.oldName !== value) {
            this.$axios({
              method: 'post',
              headers: {
                'Authorization': this.$store.state.user.token,
                'ModuleId': this.thisModule.id
              },
              url: this.myOption.requestUrl + this.thisModule.exists,
              data: this.qs.stringify({
                ideaTypeName: value
              })
            }).then((res) => {
              let code = res.data.code
              if (code === 200) {
                if (res.data.data.exists) {
                  callback(new Error('创意类型名称已存在'))
                } else {
                  callback()
                }
              } else {
                this.myOption.abnormalCode(this, code)
              }
            }).catch((err) => {
              this.myOption.abnormalCode(this, err)
            })
          } else {
            callback()
          }
        }
      }
    }
    return {
      id: '',
      title: '',
      oldName: '',
      thisModule: {},
      isModel: this.$store.getters.isEditId,
      isLoading: false,
      required: ['选填', '必填'],
      imgMinNum: 1,
      form: {
        ideaTypeName: '',
        slotType: 1,
        remark: ''
      },
      rules: {
        ideaTypeName: [
          { required: true, validator: ideaTypeNameRule, trigger: 'blur' }
        ],
        slotType: [
          { required: true, message: '请选择代码位类型', trigger: 'change' }
        ]
      },
      ideaData: [
        { checked: false, tip: [], required: 1, assetsId: 1, data: {width: '', height: '', mimes: ['image/jpeg', 'image/png', 'image/gif']} },
        { checked: false, tip: [], required: 1, assetsId: 2, data: {width: '', height: '', mimes: ['image/jpeg', 'image/png', 'image/gif']} },
        { checked: false, tip: [], required: 1, assetsId: 3, data: {width: '', height: '', mimes: ['image/jpeg', 'image/png', 'image/gif']} },
        { checked: false, tip: [], required: 1, assetsId: 4, data: {width: '', height: '', mimes: ['image/jpeg', 'image/png', 'image/gif']} },
        { checked: false, tip: [], required: 1, assetsId: 5, data: {width: '', height: '', mimes: ['image/jpeg', 'image/png', 'image/gif']} },
        { checked: false, tip: [], required: 1, assetsId: 6, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 7, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 8, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 9, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 10, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 11, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 12, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 13, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 14, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 15, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 16, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 17, data: {width: '', height: '', minTime: '', maxTime: '', mimes: ['video/mp4', 'video/flv']} },
        { checked: false, tip: [], required: 1, assetsId: 18, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 19, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 20, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 21, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 22, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 23, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 24, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 25, data: {minLen: '', maxLen: ''} },
        { checked: false, tip: [], required: 1, assetsId: 26, data: {minLen: '', maxLen: ''} }
      ],
      backups: null
    }
  },
  created () {
    this.backups = JSON.parse(JSON.stringify(this.ideaData))
    let thisModule = this.myOption.requestModule.ideaType.children
    if (this.isModel === 2) {
      this.isLoading = true
      this.id = this.$store.state.user.editId
      this.title = '修改创意类型'
      this.thisModule = thisModule.modify
      this.thisModule.detail = thisModule.detail
      this.getDetail()
    } else {
      this.title = '新建创意类型'
      this.thisModule = thisModule.add
      if (this.isModel === 3) {
        this.isLoading = true
        this.id = this.$store.state.user.editId
        this.thisModule.detail = thisModule.detail
        this.getDetail()
      }
    }
  },
  methods: {
    close () {
      this.myOption.switchListAndEdit(this, true)
    },
    // 获取详情信息
    getDetail () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.detail.id
        },
        url: this.myOption.requestUrl + this.thisModule.detail.api,
        data: this.qs.stringify({
          ideaTypeId: this.id
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          let data = res.data.data
          this.oldName = data.ideaTypeName
          this.form.ideaTypeName = data.ideaTypeName
          this.form.slotType = data.slotType
          this.form.remark = data.remark
          let ideaData = JSON.parse(data.assets)
          let ideaDataOld = JSON.parse(JSON.stringify(this.ideaData))
          for (let val of ideaData) {
            val.checked = true
            val.tip = []
            ideaDataOld[val.assetsId - 1] = val
            // 适配老版本img对象
            if (val.img) {
              val.data = val.img
              delete val.img
            }
          }
          this.ideaData = ideaDataOld
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 提交表单
    submitForm (formName) {
      let ideaData = []
      let idea = JSON.parse(JSON.stringify(this.ideaData))
      let number = 0
      for (let val of idea) {
        if (val.checked) {
          number++
          if (val.tip.join('').length > 0) {
            ideaData = []
            break
          } else {
            ideaData.push(val)
            let index = ideaData.length - 1
            delete ideaData[index].checked
            delete ideaData[index].tip
          }
        }
      }
      if (number === 0) {
        this.$message.error('请至少选择一项创意类型元素')
      }
      this.$refs[formName].validate((valid) => {
        if (valid && ideaData.length > 0) {
          let param = {
            ideaTypeName: this.form.ideaTypeName,
            slotType: this.form.slotType,
            assets: JSON.stringify(ideaData),
            remark: this.form.remark
          }
          if (this.isModel === 2) {
            param.ideaTypeId = this.id
          }
          this.$axios({
            method: 'post',
            headers: {
              'Authorization': this.$store.state.user.token,
              'ModuleId': this.thisModule.id
            },
            url: this.myOption.requestUrl + this.thisModule.api,
            data: this.qs.stringify(param)
          }).then((res) => {
            let code = res.data.code
            this.isLoading = false
            if (code === 200) {
              this.$message.success(`${this.isModel === 2 ? '修改' : '新建'}创意类型成功`)
              this.$router.push({path: this.$route.path.replace('/edit', '/list')})
            } else {
              this.myOption.abnormalCode(this, code)
            }
          }).catch((err) => {
            this.isLoading = false
            this.myOption.abnormalCode(this, err)
          })
        } else {
          return false
        }
      })
    },
    // 值不能为空
    // errorNull (boolean, index) {
    //   if (!boolean) {
    //     let data = this.ideaData[index]
    //     if (index < 6) {
    //       data.data.width = ''
    //       data.data.height = ''
    //       data.data.mimes = ['image/jpeg', 'image/png', 'image/gif']
    //       data.required = 1
    //     } else {
    //       data.data.maxLen = ''
    //       data.data.minLen = ''
    //       data.required = 1
    //     }
    //     data.tip = []
    //   }
    // },
    // 值必须为正整数
    errorNumber (index, obj1, obj2) {
      let value = this.ideaData[index][obj1][obj2]
      if (!/(^[0]?$)|(^[1-9][0-9]*$)/g.test(value)) {
        if (!/(^[1-9]$)/g.test(value[0])) {
          this.ideaData[index][obj1][obj2] = 0
        } else {
          this.ideaData[index][obj1][obj2] = value.match(/[0-9]+/)[0]
        }
      }
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.ideaData = this.backups
    }
  },
  // 组件销毁监听
  beforeDestroy () {
    this.$store.dispatch('SetEditId', false)
  }
}
</script>

<style scoped>
  .idea-type{
    font-size: 0;
  }
  .idea-type>li{
    display: flex;
    align-items: center;
    padding: 5px 10px;
    border-top: 1px solid lightgray;
  }
  .idea-type>li:last-child{
    border-bottom: 1px solid lightgray;
  }
  .idea-type-param{
    display: flex;
    margin-left: 15px;
  }
  .idea-type-param>li{
    margin-right: 30px;
    height: 40px;
    line-height: 40px;
    white-space: nowrap;
  }
  .idea-type-param>li:last-child{
    margin-right: 0;
  }
  .idea-type-param>li>.el-input{
    font-size: 0;
  }
  .idea-type-param>li>span{
    font-size: 14px;
    vertical-align: middle;
  }
</style>

<style>
  .idea-type-param>li>.el-input>.el-input__inner{
    font-size: 12px;
    padding: 0 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/idea_type/Edit.vue